import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="py-12 px-4 bg-black border-t border-gray-900" data-id="element-35">
      <div className="max-w-7xl mx-auto" data-id="element-36">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-37">
          <div className="font-serif text-2xl text-gold-primary" data-id="element-38">
            Cotifunding
          </div>

          <div className="flex gap-8 text-sm text-gray-400" data-id="element-39">
            <Link to="/privacy" className="hover:text-gold-primary transition-colors" data-id="element-40">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-gold-primary transition-colors" data-id="element-41">
              Terms of Service
            </Link>
          </div>
        </div>

        <div className="text-center mt-8 text-sm text-gray-500" data-id="element-42">
          © {new Date().getFullYear()} Cotifunding. All rights reserved.
        </div>
      </div>
    </footer>;
}